module.exports = __webpack_public_path__ + "static/img/2_02.9f9866a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/03/2_02.jpg
// module id = Wod4
// module chunks = 1